import { get, isEmpty, pick, map } from 'lodash';
import { FullStory, init as fsInit } from '@fullstory/browser';

import config from '../config';
import ga from './ga';

const globalProperties = {};

const FS = isEmpty(get(config, 'full_story.orgId')) ? () => {} : FullStory;

export const addGlobalProperties = (data) => {
  let updated = false;
  map(data, (v, k) => {
    if (globalProperties[k] !== v) {
      globalProperties[k] = v;
      updated = true;
    }
  });
  if (updated) {
    FS('setProperties', {
      type: 'page',
      properties: globalProperties,
    });
  }
};

export const init = () => {
  const orgId = get(config, 'full_story.orgId');
  if (orgId) {
    fsInit({ orgId });
  }
};

export const trackEvent = (name, properties) => {
  FS('trackEvent', { name, properties });
  ga.gtag('event', name, properties);
};

export const setIdentity = (identity) => {
  if (!isEmpty(identity)) {
    FS('setIdentity', {
      uid: identity.assumed_by || identity.login_email || '',
      properties: pick(identity, [
        'assumed_by', 'company_name', 'company_type', 'company_id', 'user_id',
        'user_first_name', 'user_last_name', 'login_email',
      ]),
    });
  }
};
